import { isAfter, isFuture, isWithinRange } from "date-fns";

export function isNewCampaignForAgent(
  agentCreationDate: string | Date,
  lastVisitedDate: string | Date,
  campaign: [string, string, string]
): boolean {
  const [start, end] = campaign;
  const dateNow = new Date();

  return (
    isActiveCampaign(dateNow, campaign) &&
    isAfter(start, agentCreationDate) &&
    isAfter(start, lastVisitedDate) &&
    isFuture(end)
  );
}

export function isActiveCampaign(dateNow: Date | string, campaign: [string, string, string]): boolean {
  const [start, end] = campaign;

  return isWithinRange(dateNow, start, end);
}
